import { Dropdown, Icon, MessageBar, MessageBarType, Spinner, SpinnerSize, SpinButton, PrimaryButton, TextField } from '@fluentui/react';
import React, { useState, useEffect } from 'react';
import { Tooltip } from '@material-ui/core';
import Api from '../../services/Api'
import { UserGuideType } from "../../GlobalConst/globalEnums";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
    toolbar: [
      [{ 'font': [] }, { 'size': [] }],
      [ 'bold', 'italic', 'underline', 'strike' ],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'super' }, { 'script': 'sub' }],
      [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block' ],
      [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
      [ 'direction', { 'align': [] }],
      [ 'link', 'image', 'video', 'formula' ],
      [ 'clean' ]
    ]
}

const UserGuide = ({adminEditMode, userGuideType}) => {

  const [isLoading, setLoading] = useState(false)
  const [userGuides, setUserGuides] = useState([])
  const [showGroup, setShowGroup] = useState({})
  const [editMode, setEditMode] = useState({})
  const [message, setMessage] = useState()
  const [isNewUserGuideVisible, setNewUserGuideVisible] = useState(false)
  const [newUserGuideType, setNewUserGuideType] = useState(userGuideType)
  const [newUserGuideOrder, setNewUserGuideOrder] = useState()
  const [newUserGuideTitle, setNewUserGuideTitle] = useState()
  const [newUserGuideContent, setNewUserGuideContent] = useState()
  const types = [{ key: UserGuideType.sharepoint, text: "SharePoint/Teams"}, { key: UserGuideType.powerPlatform, text: "Power Platform"}]

  useEffect(() => {
    const fetchData = async () => {
        await getUserGuides();
    }
    fetchData();
    }, []);

    const handleContentChange = (id, content) => {
        updateContent(id, content)
    };

    const handleNewContentChange = (content, delta, source, editor) => {
        setNewUserGuideContent(content)
    };

    const saveUserGuide = (id) => {

        setLoading(true);
        let userGuide;
        if(id === 0){
            userGuide = {id: 0, type: newUserGuideType, order: newUserGuideOrder, title: newUserGuideTitle, content: newUserGuideContent}
        } else {
            userGuide = userGuides.find((x) => x.id === id);
        }
        
        Api.post('/Settings/UserGuide', userGuide)
        .then(res => res)
        .then(post => {
            if (post.status === 200) {
                setNewUserGuideVisible(false);
                getUserGuides();
                setEditMode({...editMode, [id]: false})
                setLoading(false);
            } else {
                this.setState({ error: true })
                setMessage({
                    type: MessageBarType.error,
                    text: 'Cannot save the User Guide'
                })
                setLoading(false)
            }
        }
        ).catch((error) => {
            console.log(error)
            setLoading(false)
        });
    };

    const getUserGuides = async () => {
        setLoading(true);
        try {
            const res = await Api.get('/Settings/UserGuides/' + userGuideType);
            setUserGuides(res.data);
            setLoading(false);
        }
        catch(error) {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get User Guides from database: ' + error
            });
        }
    }

    const deleteUserGuide = (id) => {

        setLoading(true);

        Api.delete('/Settings/UserGuide/' + id)
        .then(res => res)
        .then(post => {
            if (post.status === 200) {
                setLoading(false);
                getUserGuides();
            } else {
                this.setState({ error: true })
            }
        }
        ).catch((error) => {
            console.log(error);
            setLoading(false);
        });
    };

    const discardNewUserGuide = () => {
        setNewUserGuideVisible(false)
        setNewUserGuideOrder(0)
        setNewUserGuideTitle("")
        setNewUserGuideContent("")
    }

    const createUserGuide = () => {
        saveUserGuide(0);
    }

    const discardUserGuide = (id) => {
        setEditMode({...editMode, [id]: false})
    }

    const editUserGuide = (id) => {
        setShowGroup({...showGroup, [id]: true})
        setEditMode({...editMode, [id]: true})
    }

    const updateType = (id, val) => {
        setUserGuides(userGuides.map(guide =>
            guide.id === id ? { ...guide, type: val } : guide
          ));
    }

    const updateOrder = (id, val) => {
        setUserGuides(userGuides.map(guide =>
            guide.id === id ? { ...guide, order: val } : guide
          ));
    }

    const updateTitle = (id, val) => {
        setUserGuides(userGuides.map(guide =>
            guide.id === id ? { ...guide, title: val } : guide
          ));
    }

    const updateContent = (id, val) => {
        setUserGuides(userGuides.map(guide =>
            guide.id === id ? { ...guide, content: val } : guide
          ));
    }

    const newUserGuide = 
    <div className='settings-container' style={newUserGuideContainer}>
        <div style={headerStyles}>
            <div style={iconStyles}>
                <Tooltip title="Save" placement="bottom" enterDelay={500}>
                    <Icon style={editIconStyles} onClick={() => createUserGuide()} iconName="save" />
                </Tooltip>
                <Tooltip title="Discard" placement="bottom" enterDelay={500}>
                    <Icon style={editIconStyles} onClick={() => discardNewUserGuide()} iconName="cancel" />
                </Tooltip>
            </div>
            <div style={createSpinButtonStyles}>
                <SpinButton label="Order:" onChange={(e, val) => setNewUserGuideOrder(val)}></SpinButton>
            </div>
            <div style={createDropdownStyles}>
                <Dropdown
                    placeholder="Type"
                    onChange={(e, val) => setNewUserGuideType(val.key)}
                    selectedKey={newUserGuideType}
                    options={types}
                />
            </div>
            <div style={createTextFieldStyles}>
                <TextField onChange={(e, val) => setNewUserGuideTitle(val)} type="text-box" autoComplete="off" placeholder="Title" />
            </div>
        </div>
        <div style={editorItemsStyles}>
            <ReactQuill theme="snow" modules={modules} onChange={handleNewContentChange} />
        </div>
    </div>

    const msg = message && 
    <MessageBar messageBarType={message.type}>
        {message.text}
    </MessageBar>

    const items = userGuides.map((x, index) => 
        <div key={x.id} style={index%2 === 0 ? evenStyle : oddStyle}>
            <div style={headerStyles}>
                {
                    adminEditMode &&
                    <div>
                        <div style={iconStyles}>
                            {editMode[x.id] ?
                                <div>
                                    <Tooltip title="Save" placement="bottom" enterDelay={500}>
                                        <Icon style={editIconStyles} onClick={() => saveUserGuide(x.id)} iconName="save" />
                                    </Tooltip>
                                    <Tooltip title="Discard" placement="bottom" enterDelay={500}>
                                        <Icon style={editIconStyles} onClick={() => discardUserGuide(x.id)} iconName="cancel" />
                                    </Tooltip>
                                </div>
                                :
                                <div>
                                    <Tooltip title="Edit" placement="bottom" enterDelay={500}>
                                        <Icon style={editIconStyles} onClick={() => editUserGuide(x.id)} iconName="edit" />
                                    </Tooltip>
                                    <Tooltip title="Delete" placement="bottom" enterDelay={500}>
                                        <Icon style={editIconStyles} onClick={() => deleteUserGuide(x.id)} iconName="delete" />
                                    </Tooltip>
                                </div>
                            }
                        </div>
                        {
                            editMode[x.id] && <div style={spinButtonStyles}>
                                <SpinButton label="Order:" value={x.order} onChange={(e, val) => updateOrder(x.id, val)}></SpinButton>
                            </div>
                        }
                    </div> 
                }
                <div style={arrowDivStyles}>
                    <Icon style={arrowStyles} iconName={showGroup[x.id] ? 'ChevronUp' : 'ChevronDown'} onClick={() => setShowGroup({...showGroup, [x.id]: !showGroup[x.id]})} />
                </div>
                {editMode[x.id] &&
                    <div style={dropdownStyles}>
                        <Dropdown
                            placeholder="Type"
                            onChange={(e, val) => updateType(x.id, val.key)}
                            selectedKey={x.type}
                            options={types}
                        />
                    </div>
                }
                <div style={editMode[x.id] ? textFieldStylesEditMode : textFieldStylesReadOnly}>
                    {
                        editMode[x.id] ?
                        <TextField onChange={(e, val) => updateTitle(x.id, val)} type="text-box" autoComplete="off" value={x.title} placeholder="Title" />
                        :
                        x.title
                    }
                </div>
            </div>
            {
                showGroup[x.id] &&
                (editMode[x.id] ?
                    <div style={editorItemsStyles}>
                        <ReactQuill dbId={x.id} theme="snow" modules={modules} value={userGuides.find((ug) => ug.id === x.id).content} onChange={event => handleContentChange(x.id, event)} />
                    </div>
                :
                <div className="ql-editor" style={readOnlyItemsStyles} dangerouslySetInnerHTML={{__html: x.content}} />
                )
            }
        </div> 
    )

    return (
        <div>
            {adminEditMode &&
                (
                    isNewUserGuideVisible ? newUserGuide
                    :
                    <div style={newUserGuideRowStyles}>
                        <PrimaryButton onClick={()=>setNewUserGuideVisible(true)}>Add User Guide</PrimaryButton>
                    </div>
                )
            }
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div style={userGuidesContainer}>
                    {items}
                    {msg}
                </div>
            }
        </div>
    );
}

const newUserGuideRowStyles = {
    width: '100%',
    height: '32px',
    padding: '10px'
}

const newUserGuideContainer = {
    margin: '0 20px 20px 10px'
}

const userGuidesContainer = {
    padding: '10px'
}

const evenStyle = {
    background: 'rgb(243, 242, 241)',
    padding: '18px 20px 13px 15px'
}

const oddStyle = {
    padding: '18px 20px 13px 15px'
}

const createDropdownStyles = {
    float: 'left',
    width: '200px',
    marginLeft: '29px',
    marginRight: '29px'
}

const createSpinButtonStyles = {
    float: 'right',
    width: '140px',
    marginRight: '29px'
}

const createTextFieldStyles = {
    marginLeft: '258px',
    marginRight: '254px'
}

const editorItemsStyles = {
    margin: '20px 0 0 29px',
    background: 'white'
}

const iconStyles = {
    marginRight: 10,
    float: 'right'
}

const headerStyles = {
    fontSize: 18,
    minHeight: '32px'
}

const arrowDivStyles = {
    cursor: 'pointer',
    float: 'left'
}

const arrowStyles = {
    verticalAlign: 'middle'
}

const dropdownStyles = {
    float: 'left',
    width: '200px',
    marginLeft: '12px',
    marginRight: '29px'
}

const spinButtonStyles = {
    float: 'right',
    width: '140px',
    marginRight: '29px'
}

const textFieldStylesReadOnly = {
    marginLeft: '29px',
    minHeight: '32px'
}

const textFieldStylesEditMode = {
    marginLeft: '258px',
    marginRight: '254px'
}

const editIconStyles = {
    cursor: 'pointer',
    margin: '5px 6px',
    fontSize: '18px',
    fontWeight: '600'
}

const readOnlyItemsStyles = {
    margin: '12px 0 0 29px',
    border: '1px solid rgb(96, 94, 92)',
    borderRadius: '2px',
    background: 'white'
}

export default UserGuide;



// WEBPACK FOOTER //
// ./src/components/Settings/UserGuide.js